
<div :class="jel_getClassObject(content)">
  <!-- TODO: si content.modeInscription == 'inscription' 
             alors ajouter validation de non-existence -->
  <!-- tag="div" nécessaire pour accessibilité, éviter div dans un span -->
  <ValidationProvider
    v-slot="validationContext"
    :name="content.libCourriel"
    rules="required|max:64|compteValidation:email"
    tag="div"
  >
    <b-form-group :label="content.libCourriel" label-for="courriel">
      <b-form-input
        :id="content.idHTML ? content.idHTML : 'courriel'"
        v-model="courriel"
        v-remove-extra-spaces
        trim
        :name="content.inputName ? content.inputName : 'email'"
        autocomplete="email"
        type="email"
        maxlength="64"
        :state="getValidationState(validationContext)"
      />
      <ErreurValidation
        id="courriel-live-feedback"
        :message="validationContext.errors[0]"
      ></ErreurValidation>
    </b-form-group>
  </ValidationProvider>
</div>
